var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "200px",
    viewBox: "0 0 358 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L352,0 C355.313708,-6.08718376e-16 358,2.6862915 358,6 L358,200 L358,200 L0,200 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-53.106962%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-53.106962%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9517939,0.0643082741 L25.6904111,0.0643082741 C26.3660502,0.0643082741 26.913764,0.60314908 26.913764,1.2678429 L26.913764,4.57756312 C31.3993913,10.1439108 33.642205,15.7102584 33.642205,21.276606 C33.642205,26.6715109 31.7269463,32.0664157 27.896429,37.4613205 C27.6675817,37.7836241 27.2931485,37.975649 26.8935237,37.975649 L6.748676,37.975649 C6.34905097,37.975649 5.97461756,37.7836214 5.74577265,37.4613159 C1.91525755,32.0664126 0,26.6715093 0,21.276606 C0,15.8152838 2.15897762,10.3539616 6.47693287,4.8926394 L6.72844099,4.57756312 L6.72844099,1.2678429 C6.72844099,0.60314908 7.27615474,0.0643082741 7.9517939,0.0643082741 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Knowledge-Base",
    transform: "translate(-670.000000, -791.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(670.000000, 791.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chair4",
    transform: "translate(121.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D2D2D2",
    points: "38.0773994 71.3633684 28.8305085 143.878737 33.6785328 143.814885 42.9254237 72.0423184"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D2D2D2",
    transform: "translate(44.206780, 107.621053) scale(-1, 1) translate(-44.206780, -107.621053) ",
    points: "46.4062129 71.3633684 37.159322 143.878737 42.0073464 143.814885 51.2542373 72.0423184"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D2D2D2",
    transform: "translate(72.396610, 107.621053) scale(-1, 1) translate(-72.396610, -107.621053) ",
    points: "74.5960434 71.3633684 65.3491525 143.878737 70.1971769 143.814885 79.4440678 72.0423184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,75.1861895 C-5.12399906e-16,71.0021267 3.39185303,67.6102737 7.57591579,67.6102737 L36.2176277,67.6102737 C41.9361464,67.6102737 46.7167053,63.261307 47.2561779,57.5682916 L51.7597922,10.0419821 C52.2992649,4.34896665 57.0798238,2.82683167e-15 62.7983424,0 L77.7153976,0 C83.8391309,6.51445281e-16 88.8033976,4.96426669 88.8033976,11.088 C88.8033976,11.3735808 88.7923646,11.6590549 88.7703231,11.9437838 L84.0802319,72.5298891 C83.6332137,78.3044231 78.8171168,82.7621053 73.0253063,82.7621053 L7.57591579,82.7621053 C3.39185303,82.7621053 5.12399906e-16,79.3702522 0,75.1861895 Z",
    id: "Path",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5098167,-2.27373675e-13 C78.5940788,-2.27572851e-13 79.6419918,0.155629212 80.632436,0.445768027 C80.9451316,1.46909984 81.1126682,2.5549465 81.1126682,3.67992344 C81.1126682,3.96630228 81.1015734,4.25257362 81.0794088,4.53809344 L76.3941329,64.8926963 C75.9459395,70.6662163 71.1302826,75.1225263 65.3393924,75.1225263 L0.0710895713,75.1225263 L0.00141198726,75.1219226 C0.000472087157,75.0728498 9.36073955e-17,75.0236624 0,74.9743648 C6.90201459e-15,70.8011697 3.38304303,67.4181267 7.55623809,67.4181267 L36.1074874,67.4181267 C41.8248688,67.4181267 46.6048683,63.0708379 47.1457572,57.3790992 L51.6445089,10.0390275 C52.1853978,4.34728884 56.9653973,-2.24547053e-13 62.6827787,-2.27373675e-13 L77.5098167,-2.27373675e-13 Z",
    id: "Combined-Shape",
    fill: "#B2B0B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.4",
    transform: "translate(143.000000, 100.000000) scale(-1, 1) translate(-143.000000, -100.000000) translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(28.095812, 104.572143)",
    fill: "#42474F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5578089,0.0239583835 C22.4865782,0.332679751 61.0501558,8.84438362 68.0565052,10.2904626 C75.0628546,11.7365415 80.9862694,19.5613775 75.643604,28.6221047 C69.6429264,38.7932486 54.1600796,67.6790617 50.4009647,74.1906386 C48.5403601,77.4135965 39.1539233,75.6065631 41.3587549,70.1970722 C45.4689567,60.1128105 47.3777384,34.7801842 57.8568267,25.5435349 C57.8568267,25.5435349 22.6157686,31.6640923 7.39310046,24.653177 C-3.67034187,19.5568243 -1.16748382,-0.722363271 15.5578089,0.0239583835 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(48.233675, 44.950866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7539559,14.9691812 C43.7539559,14.9691812 43.6756606,9.34318077 45.6477238,6.40300612 C47.6197871,3.46283147 47.6980824,0.339721321 49.1905869,0.441949985 C50.6830913,0.54417865 49.2052673,7.80339209 49.2052673,7.80339209 C49.2052673,7.80339209 51.0990352,7.08143271 52.4594163,6.16822259 C53.8197974,5.25501246 57.9449819,0.75303817 58.908993,1.55081306 C60.5434077,2.9101119 57.9107277,10.5777509 56.4769447,12.1106917 C55.0382683,13.6441217 47.1793759,18.6865872 47.1793759,18.6865872 L27.930075,38.3288678 L24.3159648,28.3504524 L43.7539559,14.9691812 Z",
    id: "Path",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17443202,13.1135072 C4.39753066,20.5736054 10.2991046,34.2780721 12.732053,38.3667369 C15.7810508,43.4871458 20.588914,45.7430838 26.2181763,41.9439845 C27.2144676,41.2715902 29.2302435,39.6509182 32.2655041,37.0819684 L26.7559539,24.9822585 C24.3736986,26.9443866 23.1825709,27.9254506 23.1825709,27.9254506 C23.1825709,27.9254506 17.1336808,12.4519614 12.267784,3.48835014 C8.05364948,-4.26665933 -3.73164196,1.77234046 1.17443202,13.1135072 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2450687,27.9334693 C24.3281442,31.5994299 24.996275,33.3262797 25.2494611,33.1140188 C25.5026471,32.9017579 25.4059244,30.6958628 24.9592929,26.4963335 L23.2450687,27.9334693 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65",
    fill: "#FFEDC2",
    points: "25.3868608 25.6519429 29.9941777 41.0498327 34.8876869 37.2170575 28.0767959 23.5666205"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(19.601316, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.138413, 26.006106) rotate(12.000000) translate(-17.138413, -26.006106) translate(4.638413, 2.506106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0163476,2.52384796 C15.0163476,2.52384796 11.8189091,-0.874736997 8.12663798,0.215706149 C4.43436683,1.30614929 1.09450335,7.99040303 2.68033781,14.2734713 C4.258163,20.5573534 3.07279179,21.8504237 1.15857746,26.0852491 C-3.98337064,37.477125 9.65640758,46.6376611 9.65640758,46.6376611 L24.5218073,43.4844855 L19.2114607,15.7382457 L15.0163476,2.52384796 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60573034,6.05912321 C0.946484892,15.1193069 8.45698015,21.9039706 9.87150153,23.5710627 C14.7342576,36.8549097 10.8658919,38.4117241 5.45428699,42.7602561 L8.36416932,46.0782484 L16.705618,42.5985405 L16.4377363,5.33090171 L9.60573034,6.05912321 Z",
    id: "Path-50",
    fillOpacity: 0.199355332,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.0505738,42.4330832 C13.0505738,42.4330832 18.3286912,41.3744554 18.4854547,33.9856142 C18.6422182,26.596773 17.772826,24.0746005 17.772826,24.0746005 L27.7263429,23.8953704 C27.7263429,23.8953704 27.8346809,32.1301154 27.8363888,35.1086517 C27.8405414,42.3508232 33.4264113,43.1908523 33.4264113,43.1908523 C33.4264113,43.1908523 32.2652166,48.9197345 23.2461257,49.4258266 C16.2042272,49.8215834 13.0505738,42.4330832 13.0505738,42.4330832 Z",
    id: "Path",
    fill: "#F9C7B0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(27.088481, 21.339154) rotate(12.000000) translate(-27.088481, -21.339154) translate(13.588481, 5.339154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99507084,4.91283337 C0.754135995,0.819398166 7.42356994,-1.65663627 9.3832083,1.29241962 C9.3832083,1.29241962 10.343892,4.08744101 8.34111738,5.68314635 C5.63148117,7.83523319 1.99507084,4.91283337 1.99507084,4.91283337 Z",
    id: "Path",
    fill: "#FB9934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36012407,15.8455964 C-1.08012359,15.6741363 -0.355867602,22.1608032 4.25671607,22.1519971 C4.25671607,22.1519971 6.93577502,31.3666918 16.2371241,31.3666918 C23.7910189,31.3666918 24.2824127,20.6267941 24.3509318,18.4843202 C24.4246418,16.1999127 24.4339853,8.69503804 24.4339853,8.69503804 L3.18726898,8.68519592 L3.36012407,15.8455964 Z",
    id: "Path",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68991661,19.8457297 C6.44588874,19.6394968 6.65054456,15.4507866 6.65054456,15.4507866 C8.91267742,15.0026284 9.31095856,14.4928779 11.0204285,11.6940054 C18.6126646,13.3090922 23.7674292,13.8023703 24.4339853,19.35044 C24.4339853,19.35044 30.1358332,6.53987158 20.1456209,1.98657239 C11.3584611,-2.01272859 2.08695148,1.7447899 0.469333713,8.72921117 C-0.676817569,13.6593909 0.636808086,17.2801989 0.636808086,17.2801989 C0.636808086,17.2801989 1.7878481,15.4507866 3.67731136,15.907702 C5.56677462,16.3646174 4.93394449,20.0519626 5.68991661,19.8457297 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6082509,24.4359101 C14.6082509,24.4359101 16.1367987,26.9009044 19.1187374,26.0266653",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(16.863494, 25.325088) rotate(-18.000000) translate(-16.863494, -25.325088) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9026814,27.3780643 C16.6026861,27.6711985 17.2666615,27.6711504 17.8477018,27.3341945",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(16.875192, 27.463447) rotate(2.000000) translate(-16.875192, -27.463447) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56527007,19.4437245 C3.84381553,18.4401481 3.71978627,17.5634274 2.72095675,17.1624167",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(3.207757, 18.303071) rotate(-13.000000) translate(-3.207757, -18.303071) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(16.705618, 41.324061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.240977,0.879634351 C34.3623383,0.873792271 38.6189113,2.73749903 39.1090437,3.45602026 C42.3020205,8.13684054 48.1646645,24.6117358 48.4664828,28.1856959 C48.8065348,32.3082706 42.8590706,38.8754483 42.7862023,44.8434665 C42.7214306,50.8122978 45.3302177,68.7838292 44.3181584,70.4626138 C43.3141955,72.1413984 36.7155687,80.1158284 35.3391681,80.1483473 C33.9546709,80.1808661 32.9212516,75.9940667 30.8242647,76.0851195 C28.7353742,76.1761722 24.3794709,81.7271365 22.5010888,81.6877254 C20.6308031,81.6466524 1.24784295,69.3772978 2.7294978,65.8815236 C4.21924913,62.3857494 11.1336384,53.6983439 10.4292451,48.9351483 C9.73294833,44.1727657 4.17067028,26.5922732 2.16274458,20.6088085 C0.162915349,14.6253438 -1.4482831,9.85889628 2.2841917,7.28421791 C6.01666649,4.70953955 18.1613784,0 18.1613784,0 L29.0349438,6.07776932 C29.0349438,6.07776932 33.6096907,0.91002314 34.240977,0.879634351 Z",
    id: "Path",
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3748302,5.90884105 C33.6360477,16.7454764 38.1117612,27.4232806 39.9044924,37.5846916 L34.6903564,34.777685 L29.8811216,38.4188959 C30.2206439,27.8544949 28.4456094,16.7618942 27.6295622,5.90884105 L30.3748302,5.90884105 Z",
    id: "Path",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3262844,14.2296681 L11.2024577,15.1059756 C9.74138859,25.9883518 11.470343,39.1936329 14.46661,41.2082685 C17.5252991,43.2648757 29.4300075,41.2466585 29.4300075,42.8753606 C29.4300075,44.5040627 12.9784494,59.4301942 15.6792049,66.5655835 C17.1641221,70.4887312 16.6668847,73.9777846 14.1874925,77.0327438 L13.4675033,76.54922 C7.84836186,72.7409241 1.88289122,67.878983 2.7294978,65.8815236 C4.21924913,62.3857494 11.1336384,53.6983439 10.4292451,48.9351483 C9.7608002,44.363261 4.60786695,27.9782036 2.42021765,21.3809274 L1.72333476,19.2892408 C0.913409649,16.8367072 0.239301136,14.6150892 0.0763650913,12.6982263 L0.579072722,12.3725134 C8.61436519,7.2257078 12.1966697,7.8448845 11.3262844,14.2296681 L11.3262844,14.2296681 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1544101,0.767421869 L18.1613784,0 L29.2736446,5.7632504 C29.2736446,5.7632504 27.184085,11.0761096 23.4839952,8.43046064 C20.3124897,6.16812333 21.6504686,4.17729844 19.1644708,3.15034264 C16.6867321,2.12338684 16.1544101,0.767421869 16.1544101,0.767421869 Z",
    id: "Path",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2736446,5.7632504 C30.0791732,7.55095608 31.7168469,8.59557203 32.5634738,8.27084375 C33.9608193,7.73444704 33.3607827,5.59736093 33.9115013,4.51776691 C34.3060459,3.75185021 34.5608559,3.63624014 34.9060825,2.91707751 C35.22665,2.25742006 35.2399234,1.46566723 35.1577266,1.24719821 L34.0645093,0.750754975 C33.0629912,1.69449998 32.3292564,2.41660749 31.8633047,2.91707751 C31.2826172,3.54078317 30.4193972,4.48950746 29.2736446,5.7632504 Z",
    id: "Path",
    fill: "#FFF6E1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 47.663679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7453483,28.1264258 C33.7453483,28.1264258 40.2875493,22.3482111 42.290264,21.6776565 C44.2929786,21.0071019 56.0224577,20.201556 55.9486333,21.7167844 C55.8642185,23.3401038 49.5643212,23.2466859 48.9115846,24.0453844 C48.258848,24.8435938 48.1104987,30.3019378 45.6429565,30.9147788 C43.1803593,31.5276197 35.7975127,32.5840734 35.7975127,32.5840734 L18.137644,43.2126494 L17.3831545,33.5013403 L33.7453483,28.1264258 Z",
    id: "Path",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3405146,3.6611356 C9.44790477,13.3687075 3.56316396,28.1557066 1.30431644,33.9207329 C-0.954531085,39.6857592 1.32408614,48.3812519 11.2567655,46.674152 C12.3750928,46.4821047 14.1882323,46.0007132 16.6961838,45.2299775 L19.0699688,31.8779172 C17.028827,32.7331694 16.0082561,33.1607955 16.0082561,33.1607955 C16.0082561,33.1607955 25.8803509,15.698596 28.2909787,11.0174357 C32.3176199,3.19961275 22.4117253,-4.89218367 16.3405146,3.6611356 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0082561,33.1607955 C12.6653131,34.7902456 11.2040561,35.2465923 11.6244848,34.5298357 C12.0449136,33.8130791 14.1366675,32.2247829 17.8997464,29.7649469 L16.0082561,33.1607955 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64",
    fill: "#FFEDC2",
    points: "16.4864704 32.5438318 14.8467867 46.9816872 21.3311677 44.9247762 20.3526739 30.7756354"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(15.946272, 101.541066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75664514,0.133716263 C-1.98372071,13.2761918 -1.12898443,22.7825046 9.32085399,28.6526546 C22.7072911,36.1724258 63.9943781,27.364447 63.9943781,27.364447 C63.9943781,27.364447 63.2620394,33.2483662 63.9943781,38.496113 C65.9070666,52.201937 75.0036371,75.0365402 76.928246,77.9057637 C79.5897576,81.8735684 87.6972529,78.8812289 87.849969,75.5774089 C88.0026851,72.2735888 81.7381262,30.0782435 80.7854818,22.0318866 C79.837748,13.9850396 76.8456442,12.8162059 68.1064725,10.6165465 C66.0987698,10.1112054 42.3564537,4.22311044 40.1814537,4.39473083 C27.7225776,5.37781 16.5809747,3.95747182 6.75664514,0.133716263 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2803841,26.4617315 C29.8340226,27.9772698 65.7167208,24.8533224 67.1578503,26.2728478 C68.5337724,27.6281435 68.3041579,51.2078824 71.3908562,64.8547044 C68.3504318,56.5855581 65.0591838,46.1262313 63.9943781,38.496113 C63.2620394,33.2483662 63.9943781,27.364447 63.9943781,27.364447 L62.5924007,27.6436291 C55.2770291,29.0616552 21.3630209,35.1498812 9.32085399,28.6526546 C2.25776429,24.8418376 -0.474981297,18.9415195 1.12261724,10.9517003 C3.04890531,20.3771689 8.10162712,25.5472007 16.2803841,26.4617315 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.439941406
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(86.565475, 23.111959) rotate(13.000000) translate(-86.565475, -23.111959) ",
    cx: 86.565475,
    cy: 23.111959,
    rx: 2.2777999,
    ry: 4.16816939
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(75.934627, 20.459767) rotate(-16.000000) translate(-75.934627, -20.459767) ",
    cx: 75.9346272,
    cy: 20.459767,
    rx: 3.03690645,
    ry: 4.54733403
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Example-Task1",
    transform: "translate(97.771452, 58.163831) rotate(-28.000000) translate(-97.771452, -58.163831) translate(85.271452, 37.163831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71570193,1.90615522 L22.5620764,9.4668398 C23.4742246,9.83277039 24.0816795,10.7057639 24.1077854,11.6882292 L24.8185919,38.4386482 C24.8547388,39.7989976 23.7812606,40.9310816 22.4209111,40.9672285 C22.1373268,40.9747639 21.854571,40.933271 21.5851076,40.8445789 L2.18972545,34.4607179 C1.18404926,34.1297062 0.502254402,33.1932451 0.496120544,32.1345121 L0.334321725,4.20726961 C0.326437776,2.84646282 1.42319844,1.73691975 2.78400522,1.72903581 C3.10311001,1.72718705 3.41953569,1.78734088 3.71570193,1.90615522 Z",
    id: "Rectangle",
    fill: "#7596FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48219877,2.18570437 L23.3253335,8.67607053 C24.3195595,9.01852366 24.9868955,9.95419536 24.9868955,11.0057463 L24.9868955,37.9875475 C24.9868955,39.3483771 23.8837251,40.4515475 22.5228955,40.4515475 C22.2498208,40.4515475 21.9786455,40.4061541 21.7204574,40.3172233 L2.87732263,33.8268571 C1.88309669,33.484404 1.2157607,32.5487323 1.2157607,31.4971813 L1.2157607,4.51538013 C1.2157607,3.15455051 2.31893108,2.05138013 3.6797607,2.05138013 C3.95283539,2.05138013 4.22401068,2.09677356 4.48219877,2.18570437 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "2.39909772 3.14034756 23.8306285 10.2349244 23.8306285 39.3258335 2.69068742 31.9104437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99029695,2.41375834 L17.6860176,5.24974005 C18.2911522,5.4727407 18.7032467,6.0372456 18.7312563,6.68155349 L18.8397388,9.17698649 C18.858928,9.61839739 18.5166497,9.99178754 18.0752388,10.0109767 C17.9692532,10.0155842 17.8634096,9.99906598 17.7638679,9.96238343 L10.0681472,7.12640173 C9.46301257,6.90340108 9.05091813,6.33889617 9.02290851,5.69458829 L8.91442603,3.19915528 C8.89523683,2.75774439 9.23751515,2.38435424 9.67892604,2.36516504 C9.78491163,2.36055759 9.89075518,2.3770758 9.99029695,2.41375834 Z",
    id: "Rectangle",
    fill: "#7367F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9851517,14.567309 C16.3208748,14.567309 16.5930321,14.8386515 16.5930321,15.1733696 C16.5930321,15.4841792 16.3583658,15.7403436 16.0560434,15.7753528 L15.9851517,15.7794302 L6.45604097,12.6050678 C6.12031792,12.6050678 5.84816062,12.3337252 5.84816062,11.9990072 C5.84816062,11.6881976 6.08282687,11.4320331 6.38514928,11.397024 L6.45604097,11.3929466 L15.9851517,14.567309 Z",
    id: "Path",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9851517,20.627915 C16.3208748,20.627915 16.5930321,20.8992576 16.5930321,21.2339756 C16.5930321,21.5447852 16.3583658,21.8009497 16.0560434,21.8359588 L15.9851517,21.8400362 L6.45604097,18.6656738 C6.12031792,18.6656738 5.84816062,18.3943313 5.84816062,18.0596132 C5.84816062,17.7488036 6.08282687,17.4926392 6.38514928,17.45763 L6.45604097,17.4535526 L15.9851517,20.627915 Z",
    id: "Path",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9851517,26.6885211 C16.3208748,26.6885211 16.5930321,26.9598637 16.5930321,27.2945817 C16.5930321,27.6053913 16.3583658,27.8615557 16.0560434,27.8965649 L15.9851517,27.9006423 L6.45604097,24.7262799 C6.12031792,24.7262799 5.84816062,24.4549373 5.84816062,24.1202193 C5.84816062,23.8094097 6.08282687,23.5532453 6.38514928,23.5182361 L6.45604097,23.5141587 L15.9851517,26.6885211 Z",
    id: "Path",
    fill: "#A7C3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(8.649351, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "69.647522 3.79880597 84.9560049 3.79880597 84.9560049 100.493493 69.647522 100.493493"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "69.647522 -1.78512303e-13 78.8326117 -1.78512303e-13 78.8326117 100.493493 69.647522 100.493493"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "1.05161699e-15 3.79880597 75.77699 3.79880597 75.77699 32.800658 15.3084828 32.800658 15.3084828 100.493493 1.05161699e-15 100.493493"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "1.01974981e-15 3.79880597 9.18508969 3.79880597 9.18508969 100.493493 1.01974981e-15 100.493493"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "198.150356 3.79880597 213.458839 3.79880597 213.458839 100.493493 198.150356 100.493493"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "128.502834 3.79880597 204.279824 3.79880597 204.279824 39.6988072 143.811317 39.6988072 143.811317 100.493493 128.502834 100.493493"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "20.8900621 -2.81575148e-13 137.599019 -4.04882098e-13 137.599019 39.6281791 20.8900621 39.6281791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C3C3C3",
    points: "126.206561 3.79880597 135.391651 3.79880597 135.391651 39.6281791 126.206561 39.6281791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "128.502834 3.79880597 137.687923 3.79880597 137.687923 100.493493 128.502834 100.493493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.299188,0 L216.18637,0 C219.333404,2.97461293e-15 221.884579,2.55117505 221.884579,5.69820896 C221.884579,8.84524286 219.333404,11.3964179 216.18637,11.3964179 L137.299188,11.3964179 C134.152154,11.3964179 131.600979,8.84524286 131.600979,5.69820896 C131.600979,2.55117505 134.152154,5.7810075e-16 137.299188,0 Z",
    id: "Rectangle",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "11.7938766 2.27928358 128.502834 2.27928358 128.502834 13.6757015 11.7938766 13.6757015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16375037,-1.78139615e-14 L139.643956,-1.78139615e-14 C142.79099,6.58155786e-15 145.342165,2.55117505 145.342165,5.69820896 C145.342165,8.84524286 142.79099,11.3964179 139.643956,11.3964179 L6.16375037,11.3964179 C3.01671646,11.3964179 0.465541415,8.84524286 0.465541415,5.69820896 C0.465541415,2.55117505 3.01671646,-1.90122176e-14 6.16375037,-1.78139615e-14 Z",
    id: "Rectangle",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cup",
    transform: "translate(152.000000, 93.000000) scale(-1, 1) translate(-152.000000, -93.000000) translate(142.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19568465,1.43081857 L1.34615385,1.43081857 C0.602693606,1.43081857 0,2.01844484 0,2.74331857 L0,4.54109944 C0,6.25886013 1.42822582,7.65138031 3.19003166,7.65138031 L5.19568465,7.65138031 C5.51431047,7.65138031 5.77260773,7.39954048 5.77260773,7.08888031 C5.77260773,6.77822014 5.51431047,6.52638031 5.19568465,6.52638031 L3.19003166,6.52638031 C2.06547746,6.52638031 1.15384615,5.63753979 1.15384615,4.54109944 L1.15384615,2.74331857 C1.15384615,2.63976518 1.23994524,2.55581857 1.34615385,2.55581857 L5.19568465,2.55581857 C5.51431047,2.55581857 5.77260773,2.30397874 5.77260773,1.99331857 C5.77260773,1.6826584 5.51431047,1.43081857 5.19568465,1.43081857 Z",
    id: "Path",
    fill: "#8C81FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9788065,0 C18.8284754,0 19.5172681,0.671572875 19.5172681,1.5 L19.5172681,5.25 C19.5172681,7.94994814 17.4269002,10.1738705 14.7380399,10.4671887 L14.7373925,11.25 L8.00307021,11.25 L8.00270748,10.4501133 C5.38160823,10.0962583 3.36342192,7.9029233 3.36342192,5.25 L3.36342192,1.5 C3.36342192,0.671572875 4.05221461,0 4.90188346,0 L17.9788065,0 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45192308,10.5 L18.8557692,10.5 C19.062876,10.5 19.2307692,10.6678932 19.2307692,10.875 C19.2307692,11.0859183 19.067031,11.260612 18.8565543,11.2742533 L13.1958688,11.6411283 L13.1958688,11.6411283 L9.15740727,11.6411283 L3.45114965,11.2740722 C3.24069398,11.2605346 3.07692308,11.0858906 3.07692308,10.875 C3.07692308,10.6678932 3.2448163,10.5 3.45192308,10.5 Z",
    id: "Rectangle",
    fill: "#8C81FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FacingBack-Laptop3",
    transform: "translate(51.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02733468,31.5850752 L78.9150653,31.5850752 C79.4927677,31.5850752 79.961088,32.0533955 79.961088,32.6310979 C79.961088,33.2088002 79.4927677,33.6771206 78.9150653,33.6771206 L5.02733468,33.6771206 C4.4496323,33.6771206 3.981312,33.2088002 3.981312,32.6310979 C3.981312,32.0533955 4.4496323,31.5850752 5.02733468,31.5850752 Z",
    id: "Rectangle",
    fill: "#8C81FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0781141,31.5850752 L78.9150653,31.5850752 C79.4927677,31.5850752 79.961088,32.0533955 79.961088,32.6310979 C79.961088,33.2088002 79.4927677,33.6771206 78.9150653,33.6771206 L55.0781141,33.6771206 C54.5004117,33.6771206 54.0320914,33.2088002 54.0320914,32.6310979 C54.0320914,32.0533955 54.5004117,31.5850752 55.0781141,31.5850752 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09537739,0 L48.43326,0 C50.2430453,-7.76541381e-16 51.7715044,1.34357648 52.0035468,3.13842446 L55.1677767,27.6137427 C55.4226979,29.5855577 54.0308804,31.390684 52.0590654,31.6456051 C51.9060029,31.6653934 51.7518263,31.6753183 51.5974899,31.6753183 L7.25960729,31.6753183 C5.44982197,31.6753183 3.92136287,30.3317418 3.68932047,28.5368938 L0.525090568,4.06157554 C0.270169435,2.08976058 1.66198688,0.284634308 3.63380185,0.0297131743 C3.78686438,0.00992487057 3.94104102,2.8351131e-17 4.09537739,0 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09537739,0 L46.7952345,0 C48.6050198,9.99815459e-16 50.1334789,1.34357648 50.3655213,3.13842446 L53.5297512,27.6137427 C53.7846723,29.5855577 52.3928549,31.390684 50.4210399,31.6456051 C50.2679774,31.6653934 50.1138008,31.6753183 49.9594644,31.6753183 L7.25960729,31.6753183 C5.44982197,31.6753183 3.92136287,30.3317418 3.68932047,28.5368938 L0.525090568,4.06157554 C0.270169435,2.08976058 1.66198688,0.284634308 3.63380185,0.0297131743 C3.78686438,0.00992487057 3.94104102,1.36061876e-15 4.09537739,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(26.186068, 16.341677) rotate(-37.000000) translate(-26.186068, -16.341677) ",
    cx: 26.1860681,
    cy: 16.3416773,
    rx: 3.24871138,
    ry: 3.53587345
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(186.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9793783,58.2341343 C30.3457527,43.9908717 36.1295112,29.3627805 41.4243368,14.4117401 C29.2281594,25.7800147 19.7440494,39.6299095 21.094578,58.2341343 L23.9793783,58.2341343 Z",
    id: "Path-113",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5861446,59.72149 C19.079344,35.4349795 19.7178446,12.879603 32.3470116,0 C30.6050123,26.6653355 27.3463842,45.4498771 23.2192603,59.72149 L20.5861446,59.72149 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0066999,57.1923582 C12.950821,40.2208659 5.86072321,35.3560185 2.45563569e-14,17.9350541 C19.1807249,27.7711831 20.3830768,35.8932679 24.1479585,57.1923582 L20.0066999,57.1923582 Z",
    id: "Path-112",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.209218,57.1923582 L3.55146345,40.2208659 C9.66463154,41.944202 19.8826357,44.7348338 19.8826357,57.1923582 L16.209218,57.1923582 Z",
    id: "Path-114",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0478916,57.1923582 L32.2705097,57.1923582 C34.9538941,51.6512856 38.7353194,47.8367191 47.8835909,52.4607212 C41.8869707,43.4274953 29.5831436,40.6937123 28.0478916,57.1923582 Z",
    id: "Path-116",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1637103,57.1923582 L27.6751525,57.1923582 C34.1197035,48.0779082 36.8905412,44.1064703 43.5597821,36.3229372 C34.7741294,39.6199247 25.7558934,44.1064703 24.1637103,57.1923582 Z",
    id: "Path-117",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(7.384615, 55.812500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#7367F0",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.28173518,-0.977871883 L11.6218526,-0.977871883 C4.00803723,16.4583352 19.0267352,26.7841096 11.6218526,44.1546766 L-4.28173518,44.1546766 L-4.28173518,-0.977871883 Z",
    id: "Rectangle",
    fill: "#857AF9",
    mask: "url(#mask-6)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.03e998e93b3db97516c8cd802893c362.svg";
export { ForwardRef as ReactComponent };